import {AfterViewInit, Component, ElementRef, Inject, OnDestroy, OnInit, Renderer2, ViewChild} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {User} from 'projects/core/src/lib/login/data/user';
import {UserService} from 'projects/core/src/lib/login/data/user.service';
import {Task} from '../../../../../data/tasks/task';
import {AppStateQuery} from 'projects/desktop/src/app/data/app-state.query';
import {ProjectService} from 'projects/app-misc/src/app/modules/project-misc/data/project/project.service';
import {TasksService} from '../../../../../data/tasks/tasks.service';
import {ConfirmationService} from 'primeng/api';
import {Subject, Subscription, timer} from 'rxjs';
import {TaskCommentsComponent} from '../task-comments/task-comments.component';
import {TrelloChecklist} from 'projects/app-misc/src/app/modules/trello-misc/data/trello-checklist';
import moment from 'moment-business-days';
import {CreateMessageDialogComponent} from 'projects/app-misc/src/app/modules/project-misc/view/blocks/client-messages-block/create-message-dialog/create-message-dialog.component';
import {ProjectActivityService} from 'projects/app-misc/src/app/modules/project-misc/data/project/activity/project-activity.service';
import {takeUntil} from 'rxjs/operators';
import {RxJSUnsubscribe} from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import {RxJSUnsubscribable} from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import {FilesObj} from '../task-files/task-files.component';
import {HttpEventType, HttpResponse} from '@angular/common/http';
import {MiscSnackBarService} from 'projects/core/src/lib/misc/view/snackbar/misc-snackbar.service';
import {ProjectFile} from 'projects/app-misc/src/app/modules/project-misc/data/project/project-file';
import {ShortProject} from 'projects/app-misc/src/app/modules/project-misc/data/project/short-project';
import {DeviceDetectorService} from 'ngx-device-detector';
import {PdfPreviewDialogComponent} from '../../../../../../../../../../app-misc/src/app/modules/project-misc/view/pdf-preview-dialog/pdf-preview-dialog.component';

@Component({
    selector: 'app-task-edit-dialog',
    templateUrl: './task-edit-dialog.component.html',
    styleUrls: ['./task-edit-dialog.component.scss'],
    providers: [ConfirmationService]
})
@RxJSUnsubscribe
export class TaskEditDialogComponent implements OnInit, OnDestroy, RxJSUnsubscribable, AfterViewInit {
    shortProjects: ShortProject[];
    selectedShortProj: ShortProject;

    users: User[];
    selectedUser: User;
    currentUser: User;

    loadingSpinner = false;
    projectsLoading = false;

    buttonLabel: string;
    header: string;

    task: Task;
    tempTask: Task;
    tasksForMe = false;

    deleteLoadingSpinner: boolean;
    taskType: string;
    projectId: number;
    projectName: string;

    @ViewChild('taskTextArea', {static: false})
    taskTextArea: ElementRef;

    timerSub: Subscription;

    ctrlEnterWork: boolean;

    tempKey: any;

    ctrlEventListener = null;
    deleteEventListener = null;

    checkList: TrelloChecklist;

    requiredParam = true;

    activityDots = new Map();

    filesToUpload: File[]

    originalTask: Task;

    constructor(
        protected deviceService: DeviceDetectorService,
        private snackBar: MatSnackBar,
        protected dialogRef: MatDialogRef<TaskEditDialogComponent>,
        protected dialog: MatDialog,
        protected projectService: ProjectService,
        protected userService: UserService,
        protected tasksService: TasksService,
        protected confirmationService: ConfirmationService,
        protected projectActivityService: ProjectActivityService,
        protected appStateQuery: AppStateQuery,
        protected el: ElementRef,
        private snackBarService: MiscSnackBarService,
        protected renderer: Renderer2,
        @Inject(MAT_DIALOG_DATA) public data: {
            task: Task,
            buttonLabel: string,
            tasksForMe?: boolean,
            taskType?: string,
            entityId?: number,
            projectId?: number,
            projectName?: string,
            checkList?: TrelloChecklist
        }
    ) {
        this.task = data.task
        this.buttonLabel = data.buttonLabel;
        this.tasksForMe = data.tasksForMe;
        this.taskType = data.taskType;
        this.projectId = data.projectId ? data.projectId : (this.task && this.task.project ? this.task.project.id : null);
        this.projectName = data.projectName ? data.projectName : (this.task && this.task.project && this.task.project.name ? this.task.project.name : null);
        this.checkList = data.checkList;
    }

    ngOnInit() {
        this.ctrlEnterWork = true;

        this.subToCTRLEnter();

        if (this.task && this.task.id) {
            this.getTask()
        } else {
            this.getCurrentUser();
            this.getUsers();
            this.getProjects();
            this.tempTask = new Task();

            if (this.task && this.task.checkitemIds) {
                this.tempTask = Object.assign(new Task(), this.task)
                this.tempTask.deadline = moment().businessAdd(5).toDate();

                this.tempTask.isSample = !!this.tempTask.checkitems.find(checkitem => checkitem.name.toLowerCase().includes('sample'))

                this.requiredParam = false;
            }
        }

    }

    addClass() {
        (this.el.nativeElement as HTMLElement).parentElement.parentElement.classList.add('checkitems-exist')
    }

    getTask() {
        this.projectsLoading = true;

        this.tasksService.getTask(this.task.id, this.task.clazz).subscribe(newTask => {
            this.updateTask(newTask)
        });
    }

    updateTask(newTask: Task) {
        this.task = newTask;

        this.originalTask = Object.assign(new Task(), newTask);
        this.tempTask = Object.assign(new Task(), this.task);

        if (this.tempTask.clientNotifications && this.tempTask.clientNotifications.length > 1) {
            this.tempTask.clientNotifications.sort((a, b) => {
                return b.createdTime.getDate() - a.createdTime.getDate()
            });
        }

        if (newTask.project && newTask.project.id) {
            this.projectId = newTask.project.id;
            this.projectName = newTask.project.name;
        }


        this.getCurrentUser();
        this.getUsers();
        this.getProjects();

    }

    subToCTRLEnter() {
        this.ctrlEventListener = (event: KeyboardEvent) => {
            this.ctrlEnterEvent(event)
        }

        document.addEventListener('keydown', this.ctrlEventListener);
    }

    ctrlEnterEvent(event) {
        const key = (event as KeyboardEvent).key; // const {key} = event; in ES6+

        if (this.tempKey === 'Control') {
            if (key === 'Enter') {
                if (this.selectedUser && this.tempTask.text) {
                    if (this.ctrlEnterWork) {
                        this.saveTask();
                    }
                }
            }
        }
        this.tempKey = key;

        if (!this.timerSub) {
            this.timerSub = timer(500).subscribe(() => {
                this.tempKey = null;
                this.timerSub = null;
            })
        }
    }

    getCurrentUser() {
        this.appStateQuery.currentUser$.subscribe(user => this.currentUser = user)
    }

    getUsers() {
        this.userService.getActiveUsers().pipe(takeUntil(this.getUnsubFromAllSubs())).subscribe(users => {
            this.users = users;

            if (this.task) {
                if (this.task.assignedUser) {
                    this.selectedUser = this.users.find(user => user.id === this.task.assignedUser.id)


                    if (!this.selectedUser) {
                        this.users.unshift({
                            id: this.task.assignedUser.id,
                            name: this.task.assignedUser.name
                        })

                        this.selectedUser = this.users[0]
                    }
                } else if (this.task.checkitemIds && this.buttonLabel === 'Create') {
                    this.selectedUser = this.users.find(user => user.roles.find(role => role.name === 'Service Department'))
                }

            } else {
                if (this.tasksForMe) {
                    this.selectedUser = this.users.find(user => user.id === this.currentUser.id)
                }
            }
        })

    }

    getProjects() {
        this.projectService.getShortLastProjects().subscribe(projs => {
            this.shortProjects = projs;

            if (this.task) {
                if (this.task.project) {
                    this.selectedShortProj = this.shortProjects.find(proj => proj.id === this.task.project.id)
                    if (typeof this.selectedShortProj === 'undefined') {
                        this.shortProjects.unshift(this.task.project)
                        this.selectedShortProj = this.shortProjects[0]
                    }
                }
                if (this.projectId) {
                    this.findAProject();
                }
            } else {
                if (this.projectId) {
                    this.findAProject();
                }
            }

            this.projectsLoading = false;

            if (this.tempTask.checkitems) {
                this.addClass();
            }


            if (!this.deviceService.isTablet()) {
                timer(1).subscribe(() => {
                    const textarr = this.el.nativeElement.getElementsByClassName('text-area-task-block');
                    (textarr[0] as HTMLElement).focus();


                    if (this.requiredParam) {
                        (this.taskTextArea.nativeElement as HTMLElement).setAttribute('required', '');
                    }
                })
            }

            // this.selectedProj
        })
    }

    findAProject() {
        this.selectedShortProj = this.shortProjects.find(proj => proj.id === this.projectId)


        if (!this.selectedShortProj) {
            this.shortProjects.unshift({
                id: this.projectId,
                name: this.projectName
            })
            this.selectedShortProj = this.shortProjects[0]
        }
    }

    saveTask() {
        this.loadingSpinner = true;

        this.tempTask.assignedUser = this.selectedUser;

        if (this.selectedShortProj) {
            this.tempTask.project = this.selectedShortProj;
        } else {
            this.tempTask.project = null;
        }

        if (this.taskType === 'checkitem') {
            this.tempTask.entityId = this.data.entityId;
            this.createTaskForCheckItem();
        } else if (this.taskType === 'comment') {
            this.tempTask.entityId = this.data.entityId;
            this.createTaskForComment();
        } else if (this.taskType === 'order') {
            this.createWorkOrder();
        } else {
            if (this.buttonLabel === 'Create') {
                this.createTask();
            }

            if (this.buttonLabel === 'Save') {
                this.saveTaskk();
            }
        }

    }

    createTask() {
        if (this.tempTask.project)
            this.tempTask.project = Object.assign(new ShortProject(), this.tempTask.project);
        this.tasksService.createTask(this.tempTask).subscribe(task => {
            if (this.filesToUpload) {
                this.uploadFiles(task, 'Task')
            } else {
                this.dialogRef.close(task);
            }
        }, () => {
            this.loadingSpinner = false;
            this.openSnackBar('Error!', 'Error!')
        })
    }

    saveTaskk() {
        const hasItems = this.task.checkitems && this.task.checkitems.length > 0;

        let taskToSend = this.tempTask;

        if (this.originalTask) {
            if (hasItems) {
                this.tempTask.checkitemIds = this.tempTask.checkitems.map(item => item.id)
            }
            taskToSend = this.getModifiedFields();
            taskToSend.id = this.tempTask.id;
            taskToSend.clazz = this.tempTask.clazz;
        } else {
            if (hasItems) {
                this.tempTask.checkitemIds = this.tempTask.checkitems.map(item => item.id)
            }
        }

        if (this.tempTask.project)
            this.tempTask.project = Object.assign(new ShortProject(), this.tempTask.project);

        this.tasksService.updateTask(taskToSend, (hasItems || this.tempTask.clazz in ['SERVICE_ORDER_TASK', 'WORK_ORDER_TASK'])).subscribe(task => {
            this.dialogRef.close(task);
        }, error => {
            this.loadingSpinner = false;
            this.openSnackBar(error.message, 'Error!')
        })

    }

    getModifiedFields(): Task {
        const modifiedTask = new Task();

        const fieldsToCheck = [
            'text', 'deliveryInstructions', 'deadline', 'isSample', 'isLock',
            'assignedUser', 'project', 'checkitemIds'
        ];

        fieldsToCheck.forEach(field => {
            if (field === 'assignedUser') {
                if (this.tempTask.assignedUser?.id !== this.originalTask.assignedUser?.id) {
                    modifiedTask.assignedUser = this.tempTask.assignedUser;
                }
            } else if (field === 'project') {
                if (this.tempTask.project?.id !== this.originalTask.project?.id) {
                    modifiedTask.project = this.tempTask.project;
                }
            } else if (field === 'deadline') {
                const tempDate = this.tempTask.deadline ? new Date(this.tempTask.deadline).getTime() : null;
                const origDate = this.originalTask.deadline ? new Date(this.originalTask.deadline).getTime() : null;
                if (tempDate !== origDate) {
                    modifiedTask.deadline = this.tempTask.deadline;
                }
            } else if (field === 'checkitemIds') {
                const tempIds = JSON.stringify((this.tempTask.checkitems || []).map(item => item.id).sort());
                const origIds = JSON.stringify((this.originalTask.checkitems || []).map(item => item.id).sort());
                if (tempIds !== origIds) {
                    modifiedTask.checkitemIds = this.tempTask.checkitemIds;
                }
            } else {
                if (this.tempTask[field] !== this.originalTask[field]) {
                    modifiedTask[field] = this.tempTask[field];
                }
            }
        });

        return modifiedTask;
    }

    createWorkOrder() {
        this.tasksService.createWorkOrder(this.tempTask).subscribe(task => {
            if (task.project && task.project.id) {
                this.updateActivities(task.project.id);
            }

            if (this.filesToUpload) {
                this.uploadFiles(task, 'Task')
            } else {
                this.openSnackBar('Service Order Created For ' + this.tempTask.assignedUser.name, 'Success')
                this.dialogRef.close(task);
            }
        }, error => {
            this.loadingSpinner = false;
            this.openSnackBar(error.message, 'Error!')
        })
    }

    createTaskForCheckItem() {
        if (this.tempTask.project)
            this.tempTask.project = Object.assign(new ShortProject(), this.tempTask.project);
        this.tasksService.createTaskFromCheckItem(this.tempTask).subscribe(task => {
            if (this.filesToUpload) {
                this.uploadFiles(task, 'CheckItem')
            } else {
                this.openSnackBar('Task Created For ' + this.tempTask.assignedUser.name, 'Success')
                this.dialogRef.close('CheckItem');
            }
        }, () => {
            this.loadingSpinner = false;
            this.openSnackBar('Error!', 'Error!')
        })
    }

    createTaskForComment() {
        if (this.tempTask.project)
            this.tempTask.project = Object.assign(new ShortProject(), this.tempTask.project);
        this.tasksService.createTaskFromComment(this.tempTask).subscribe(task => {
            if (this.filesToUpload) {
                this.uploadFiles(task, 'Comment')
            } else {
                this.openSnackBar('Task Created For ' + this.tempTask.assignedUser.name, 'Success')
                this.dialogRef.close('Comment');
            }
        }, () => {
            this.loadingSpinner = false;
            this.openSnackBar('Error!', 'Error!')
        })
    }

    uploadFiles(newTask, closingType: string) {
        this.tasksService.uploadFile(this.filesToUpload, newTask.id).subscribe(httpEvent => {
            if (httpEvent.type === HttpEventType.Response) {
                const projectFiles = (httpEvent as HttpResponse<ProjectFile[]>).body;
                newTask.files = newTask.files.concat(projectFiles)
                newTask.hasFiles = true;
                if (closingType === 'Task') {
                    this.dialogRef.close(newTask);
                } else {
                    this.dialogRef.close(closingType);
                }
            }
        }, error => {
            this.dialogRef.close('close-button');
            this.snackBarService.openErrorSnackBar(error.message)
        })
    }

    openComments() {
        this.ctrlEnterWork = false;

        const dialogRef = this.dialog.open(TaskCommentsComponent, {
            data: {
                task: this.data.task,
                users: this.users
            },
            panelClass: 'task-comments-dialog',

            disableClose: false
        });

        dialogRef.afterClosed().subscribe(() => {
            this.ctrlEnterWork = true;
        });
    }


    deleteTask() {
        if (!this.canDeleteTask()) {
            return;
        }
        this.confirmationService.confirm({
            header: 'Delete Task?',
            message: `Delete task for ${this.task.assignedUser.name}?`,
            accept: () => {
                this.deleteTaskService();
            },
            reject: () => {
                document.removeEventListener('keydown', this.deleteEventListener);
            }
        });

        timer(5).subscribe(() => {
            this.subToDelete();
        })
    }

    canDeleteTask(): boolean {
        if (this.tempTask.clazz !== 'SERVICE_ORDER_TASK') {
            return true;
        }

        if (!this.tempTask.isLock) {
            return true;
        }

        if (this.currentUser?.serviceManagerUser === true) {
            return true;
        }

        if (this.tempTask.assignedUser?.id === this.currentUser?.id) {
            return true;
        }

        return false;
    }


    subToDelete() {
        this.deleteEventListener = (event: KeyboardEvent) => {
            this.deleteEvent(event)
        }

        document.addEventListener('keydown', this.deleteEventListener);
    }

    deleteEvent(event) {
        const key = (event as KeyboardEvent).key; // const {key} = event; in ES6+

        if (key === 'Enter') {
            this.deleteTaskService();
            document.removeEventListener('keydown', this.deleteEventListener);
            this.confirmationService.close();
        }
    }

    deleteTaskService() {
        this.deleteLoadingSpinner = true;

        this.tasksService.deleteTask(this.task.id).subscribe(() => {
                this.deleteLoadingSpinner = false;

                if (this.task.clazz === 'SERVICE_ORDER_TASK' && this.task.project && this.task.project.id) {
                    this.updateActivities(this.task.project.id);
                }

                this.dialogRef.close('DELETE');

            },
            error => {
                this.deleteLoadingSpinner = false;
                this.openSnackBar(error.message, 'Error!')
            })
    }

    updateActivities(projectId: number) {
        this.projectActivityService.getProjectActivities(projectId).subscribe(projectActivities => {
            projectActivities.forEach(activity => {
                this.projectActivityService.projectActivityEmitter.emitUpdate(activity);
            });
        })
    }

    openSnackBar(message: string, type: string) {
        let panelClass = 'task-snackbar';

        if (type === 'Error!') {
            panelClass = 'error-snackbar'
        }

        this.snackBar.open(message, '', {
            duration: 5000,
            panelClass,
            verticalPosition: 'top',
        });
    }

    closeDialog() {
        this.dialogRef.close('close-button');
    }

    // dropDownIsShown(event) {
    // 	let elem = event.element.children[0].children[0] as HTMLInputElement;
    // 	elem.addEventListener('keyup', eventtt => {
    // 		if (!this.barSubj) {
    // 			this.searchLoading = true;

    // 			this.barSubj = timer(500).pipe(
    // 				distinctUntilChanged(),
    // 				takeUntil(this.getUnsubFromAllSubs())
    // 			).subscribe(emit => {
    // 				if (elem.value.length > 0) {
    // 					this.projectService
    // 						.searchProjects(elem.value, 0, 25)
    // 						.subscribe(searchResult => {
    // 							this.shortProjects = searchResult.content;
    // 						})

    // 				}
    // 				else {
    // 					this.getProjects();
    // 				}

    // 				this.searchLoading = false;
    // 				this.barSubj = null;
    // 			})
    // 		}
    // 	});

    // }

    searchProjects() {

    }

    createMessage() {
        const dialogRef = this.dialog.open(CreateMessageDialogComponent, {
            data: {
                type: 'taskNfs',
                id: this.task.id
            },
            disableClose: true,
            panelClass: 'project-activity-dialog'
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result[0] === 'success') {
                this.tempTask.clientNotifications.unshift(result[1])
            }
        });
    }

    onShown() {
        let startDate = ''
        let endDate = ''

        startDate = moment(this.tempTask.deadline).startOf('month').format('YYYY-MM-DD')
        endDate = moment(this.tempTask.deadline).endOf('month').format('YYYY-MM-DD')

        this.getActivityDays(startDate, endDate)
        setTimeout(() => {
            const activeElement = document.activeElement;
            if (activeElement && activeElement instanceof HTMLElement)
                activeElement.blur()
        }, 50);
    }

    monthChanged(event) {
        let startDate = ''
        let endDate = '';

        startDate = moment().year(event.year).month(event.month - 1).startOf('month').format('YYYY-MM-DD')
        endDate = moment().year(event.year).month(event.month - 1).endOf('month').format('YYYY-MM-DD')


        this.getActivityDays(startDate, endDate)
    }

    getActivityDays(startDate: string, endDate: string) {
        this.activityDots.clear();

        this.projectActivityService.getServiceOrdersDays(9, startDate, endDate).subscribe(days => {
            days.forEach(day => {
                const actvts = [];

                if (day.projects) {
                    day.projects.forEach(proj => {
                        actvts.push({
                            val: proj.name,
                            id: proj.id,
                            color: '4bbdaa'
                        })
                    })
                }

                const holiday = day.holiday as string;
                if (holiday) {
                    actvts.push({
                        val: holiday,
                        color: 'c550de'
                    })
                }

                if (actvts.length > 0) {
                    this.activityDots.set(moment(day.date).format('D'), actvts)
                }
            })
        })
    }

    deleteMsg(msgId: number) {
        const msgIndex = this.tempTask.clientNotifications.findIndex(msg => msg.id === msgId);

        if (msgIndex > -1) {
            this.tempTask.clientNotifications.splice(msgIndex, 1);
        }
    }

    ngOnDestroy() {
        document.removeEventListener('keydown', this.ctrlEventListener);

        // getEventListeners(document);
    }

    getUnsubFromAllSubs(): Subject<boolean> {
        return null
    }

    newFilesEmit(filesObj: FilesObj) {
        // Ticket #3630
        // this.tempTask.files = filesObj.taskFiles
        this.filesToUpload = filesObj.files
    }

    ngAfterViewInit() {
        if (!this.deviceService.isTablet()) {
            this.taskTextArea?.nativeElement.focus()
        }
    }

    onMentionSelect(user: User) {
        return '@' + user.username + ' ';
    }

    openOrderPDF(): void {
        const cpDialogRef = this.dialog.open(PdfPreviewDialogComponent, {
            data: {
                dialogHeader: 'SO-' + this.tempTask.number,
                link: '/task/' + this.tempTask.id + '/service-order-report',
                showSendButton: true
            },
            panelClass: 'pdf-preview-dialog'
        });
        cpDialogRef.afterOpened().subscribe(() => {
        })
        cpDialogRef.afterClosed().subscribe(() => {
        })
    }

    toggleSample() {
        if (this.canEditField('isSample')) {
            this.tempTask.isSample = !this.tempTask.isSample;
            const taskToSave = new Task();
            taskToSave.id = this.tempTask.id;
            taskToSave.clazz = this.tempTask.clazz;
            taskToSave.isSample = this.tempTask.isSample;
            this.tasksService.updateTask(taskToSave, true).subscribe(task => {
                this.updateTask(task);
            }, error => {
                this.loadingSpinner = false;
                this.snackBarService.openErrorSnackBar(error.message)
            });
        }
    }

    toggleLock(): void {
        if (!this.canEditLockStatus()) {
            this.openSnackBar('You do not have permission to change the lock status of this task.\nPlease contact Service Manager.', 'Error!');
            return;
        }

        this.tempTask.isLock = !this.tempTask.isLock;
        const taskToSave = new Task();
        taskToSave.id = this.tempTask.id;
        taskToSave.clazz = this.tempTask.clazz;
        taskToSave.isLock = this.tempTask.isLock;
        this.tasksService.updateTask(taskToSave, true).subscribe(task => {
            this.updateTask(task);
        }, error => {
            this.loadingSpinner = false;
            this.snackBarService.openErrorSnackBar(error.message)
        });
    }

    canEditLockStatus(): boolean {
        if (this.tempTask.clazz !== 'SERVICE_ORDER_TASK') {
            return true;
        }
        return this.currentUser?.serviceManagerUser === true || this.currentUser?.id === this.tempTask.assignedUser?.id;
    }

    canEditField(fieldName: string): boolean {
        if (this.tempTask.clazz !== 'SERVICE_ORDER_TASK') {
            return true;
        }

        if (!this.tempTask.isLock) {
            return true;
        }

        const allowedFieldsForRegular = ['text', 'deliveryInstructions'];

        if (allowedFieldsForRegular.includes(fieldName)) {
            return true;
        }

        if (this.currentUser?.serviceManagerUser === true || this.currentUser?.id === this.tempTask.assignedUser?.id) {
            return true;
        }

        return false;
    }

    getHeaderText(): string {
        if (this.task.clazz === 'SERVICE_ORDER_TASK') {
            return (this.task.number ? 'SO-' + this.task.number : 'New SO');
        } else if (this.task.clazz === 'WORK_ORDER_TASK') {
            return (this.task.number ? 'WO-' + this.task.number : 'New WO');
        } else {
            return 'Edit Task';
        }
    }


}
